export const EARTH_EQUATORIAL_RADIUS_METERS = 6_378_137;
export const EARTH_EQUATORIAL_DIAMETER_METERS = 2 * EARTH_EQUATORIAL_RADIUS_METERS;
export const EARTH_EQUATORIAL_RADIUS_KM = EARTH_EQUATORIAL_RADIUS_METERS / 1000;
export const EARTH_EQUATORIAL_DIAMETER_KM = 2 * EARTH_EQUATORIAL_RADIUS_KM;

export const EARTH_AXIS_RATIO = 0.996647189335;

export const EARTH_FLATTENING = 1 - EARTH_AXIS_RATIO;
export const EARTH_POLAR_RADIUS_RATIO = 1 - EARTH_FLATTENING;
export const ECCENTRICITY_SQUARED = 2 * EARTH_FLATTENING - EARTH_FLATTENING * EARTH_FLATTENING;

export const EARTH_ROTATION_DEG_PER_HOUR = 1.002738 * 15;
export const EARTH_SIDEREAL_ROTATION_PER_DAY = 360.985647;

// Sun's centre altitude at sunrise/sunset: -(34' refraction + 16' semi-diameter). Meeus, chapter 15.
export const SUNRISE_SUNSET_ALTITUDE_DEG = -0.8333;

export const EARTH_ARGUMENTS_OF_NUTATION = [
    [0, 0, 0, 0, 1, -171996, -174.2, 92025, 8.9],
    [0, 0, 2, -2, 2, -13187, -1.6, 5736, -3.1],
    [0, 0, 2, 0, 2, -2274, -0.2, 977, -0.5],
    [0, 0, 0, 0, 2, 2062, 0.2, -895, 0.5],
    [0, 1, 0, 0, 0, 1426, -3.4, 54, -0.1],
    [1, 0, 0, 0, 0, 712, 0.1, -7, 0.0],
    [0, 1, 2, -2, 2, -517, 1.2, 224, -0.6],
    [0, 0, 2, 0, 1, -386, -0.4, 200, 0.0],
    [1, 0, 2, 0, 2, -301, 0.0, 129, -0.1],
    [0, -1, 2, -2, 2, 217, -0.5, -95, 0.3],
    [1, 0, 0, -2, 0, -158, 0.0, -1, 0.0],
    [0, 0, 2, -2, 1, 129, 0.1, -70, 0.0],
    [-1, 0, 2, 0, 2, 123, 0.0, -53, 0.0],
    [0, 0, 0, 2, 0, 63, 0.0, -2, 0.0],
    [1, 0, 0, 0, 1, 63, 0.1, -33, 0.0],
    [-1, 0, 2, 2, 2, -59, 0.0, 26, 0.0],
    [-1, 0, 0, 0, 1, -58, -0.1, 32, 0.0],
    [1, 0, 2, 0, 1, -51, 0.0, 27, 0.0],
    [2, 0, 0, -2, 0, 48, 0.0, 1, 0.0],
    [-2, 0, 2, 0, 1, 46, 0.0, -24, 0.0],
    [0, 0, 2, 2, 2, -38, 0.0, 16, 0.0],
    [2, 0, 2, 0, 2, -31, 0.0, 13, 0.0],
    [2, 0, 0, 0, 0, 29, 0.0, -1, 0.0],
    [1, 0, 2, -2, 2, 29, 0.0, -12, 0.0],
    [0, 0, 2, 0, 0, 26, 0.0, -1, 0.0],
    [0, 0, 2, -2, 0, -22, 0.0, 0, 0.0],
    [-1, 0, 2, 0, 1, 21, 0.0, -10, 0.0],
    [0, 2, 0, 0, 0, 17, -0.1, 0, 0.0],
    [0, 2, 2, -2, 2, -16, 0.1, 7, 0.0],
    [-1, 0, 0, 2, 1, 16, 0.0, -8, 0.0],
    [0, 1, 0, 0, 1, -15, 0.0, 9, 0.0],
    [1, 0, 0, -2, 1, -13, 0.0, 7, 0.0],
    [0, -1, 0, 0, 1, -12, 0.0, 6, 0.0],
    [2, 0, -2, 0, 0, 11, 0.0, 0, 0.0],
    [-1, 0, 2, 2, 1, -10, 0.0, 5, 0.0],
    [1, 0, 2, 2, 2, -8, 0.0, 3, 0.0],
    [1, 1, 0, -2, 0, -7, 0.0, 0, 0.0],
    [0, 1, 2, 0, 2, 7, 0.0, -3, 0.0],
    [0, -1, 2, 0, 2, -7, 0.0, 3, 0.0],
    [0, 0, 2, 2, 1, -7, 0.0, 3, 0.0],
    [-2, 0, 0, 2, 1, -6, 0.0, 3, 0.0],
    [1, 0, 0, 2, 0, 6, 0.0, 0, 0.0],
    [2, 0, 2, -2, 2, 6, 0.0, -3, 0.0],
    [0, 0, 0, 2, 1, -6, 0.0, 3, 0.0],
    [1, 0, 2, -2, 1, 6, 0.0, -3, 0.0],
    [0, -1, 2, -2, 1, -5, 0.0, 3, 0.0],
    [0, 0, 0, -2, 1, -5, 0.0, 3, 0.0],
    [1, -1, 0, 0, 0, 5, 0.0, 0, 0.0],
    [2, 0, 2, 0, 1, -5, 0.0, 3, 0.0],
    [2, 0, 0, -2, 1, 4, 0.0, -2, 0.0],
    [0, 1, 2, -2, 1, 4, 0.0, -2, 0.0],
    [1, 0, 0, -1, 0, -4, 0.0, 0, 0.0],
    [0, 1, 0, -2, 0, -4, 0.0, 0, 0.0],
    [1, 0, -2, 0, 0, 4, 0.0, 0, 0.0],
    [0, 0, 0, 1, 0, -4, 0.0, 0, 0.0],
    [-2, 0, 2, 0, 2, -3, 0.0, 1, 0.0],
    [1, -1, 0, -1, 0, -3, 0.0, 0, 0.0],
    [1, 1, 0, 0, 0, -3, 0.0, 0, 0.0],
    [1, 0, 2, 0, 0, 3, 0.0, 0, 0.0],
    [1, -1, 2, 0, 2, -3, 0.0, 1, 0.0],
    [-1, -1, 2, 2, 2, -3, 0.0, 1, 0.0],
    [3, 0, 2, 0, 2, -3, 0.0, 1, 0.0],
    [0, -1, 2, 2, 2, -3, 0.0, 1, 0.0],
    [0, -2, 2, -2, 1, -2, 0.0, 1, 0.0],
    [-2, 0, 0, 0, 1, -2, 0.0, 1, 0.0],
    [1, 1, 2, 0, 2, 2, 0.0, -1, 0.0],
    [-1, 0, 2, -2, 1, -2, 0.0, 1, 0.0],
    [2, 0, 0, 0, 1, 2, 0.0, -1, 0.0],
    [1, 0, 0, 0, 2, -2, 0.0, 1, 0.0],
    [3, 0, 0, 0, 0, 2, 0.0, 0, 0.0],
    [0, 0, 2, 1, 2, 2, 0.0, -1, 0.0],
    [-1, 0, 2, 4, 2, -2, 0.0, 1, 0.0],
    [2, 0, -2, 0, 1, 1, 0.0, 0, 0.0],
    [2, 1, 0, -2, 0, 1, 0.0, 0, 0.0],
    [0, 0, -2, 2, 1, 1, 0.0, 0, 0.0],
    [0, 1, -2, 2, 0, -1, 0.0, 0, 0.0],
    [0, 1, 0, 0, 2, 1, 0.0, 0, 0.0],
    [-1, 0, 0, 1, 1, 1, 0.0, 0, 0.0],
    [0, 1, 2, -2, 0, -1, 0.0, 0, 0.0],
    [-1, 0, 0, 0, 2, 1, 0.0, -1, 0.0],
    [1, 0, 0, -4, 0, -1, 0.0, 0, 0.0],
    [-2, 0, 2, 2, 2, 1, 0.0, -1, 0.0],
    [2, 0, 0, -4, 0, -1, 0.0, 0, 0.0],
    [1, 1, 2, -2, 2, 1, 0.0, -1, 0.0],
    [1, 0, 2, 2, 1, -1, 0.0, 1, 0.0],
    [-2, 0, 2, 4, 2, -1, 0.0, 1, 0.0],
    [-1, 0, 4, 0, 2, 1, 0.0, 0, 0.0],
    [1, -1, 0, -2, 0, 1, 0.0, 0, 0.0],
    [2, 0, 2, -2, 1, 1, 0.0, -1, 0.0],
    [2, 0, 2, 2, 2, -1, 0.0, 0, 0.0],
    [1, 0, 0, 2, 1, -1, 0.0, 0, 0.0],
    [0, 0, 4, -2, 2, 1, 0.0, 0, 0.0],
    [3, 0, 2, -2, 2, 1, 0.0, 0, 0.0],
    [1, 0, 2, -2, 0, -1, 0.0, 0, 0.0],
    [0, 1, 2, 0, 1, 1, 0.0, 0, 0.0],
    [-1, -1, 0, 2, 1, 1, 0.0, 0, 0.0],
    [0, 0, -2, 0, 1, -1, 0.0, 0, 0.0],
    [0, 0, 2, -1, 2, -1, 0.0, 0, 0.0],
    [0, 1, 0, 2, 0, -1, 0.0, 0, 0.0],
    [1, 0, -2, -2, 0, -1, 0.0, 0, 0.0],
    [0, -1, 2, 0, 1, -1, 0.0, 0, 0.0],
    [1, 1, 0, -2, 1, -1, 0.0, 0, 0.0],
    [1, 0, -2, 2, 0, -1, 0.0, 0, 0.0],
    [2, 0, 0, 2, 0, 1, 0.0, 0, 0.0],
    [0, 0, 2, 4, 2, -1, 0.0, 0, 0.0],
    [0, 1, 0, 1, 0, 1, 0.0, 0, 0.0],
];
